import { CurveModifier } from "./curves/modifiers/CurveModifier";
import { CurveModifierStack } from "./curves/CurveModifierStack";
import { ModifiableCurve } from "./curves/ModifiableCurve";
import { Instrument } from "./Instrument";
import { Curve } from "./curves/Curve";
import { Vector2 } from "three";
import { AudioBuilderContext } from "./AudioBuilderContext";
import { MidiKey } from "../midi/MidiKey";

export class Key
{
  midiKey:MidiKey = MidiKey.C4;

  velocityModifiers:CurveModifierStack = new CurveModifierStack();
  pitchModifiers:CurveModifierStack = new CurveModifierStack();

  getPitchCurve( velocityCurve:Curve, context:AudioBuilderContext )
  {
    let pitchCurve = new Curve();
    pitchCurve.add( new Vector2( 0, this.midiKey.pitch ) );
    pitchCurve.add( new Vector2( velocityCurve.end.x, this.midiKey.pitch ) );

    pitchCurve = this.pitchModifiers.modify( pitchCurve, context );

    return pitchCurve;
  }
}